var render = function render(){var _vm=this,_c=_vm._self._c;return _c('obroci-table',{attrs:{"data":_vm.data,"loading":_vm.isLoading,"search-query":_vm.searchQuery}})
}
var staticRenderFns = []

export { render, staticRenderFns }